// Фильтры - сброс +
// Таблица - сброс + 
// url - логика +
import customHeaders, { getSpace } from '../../common/headers';
import refresh_icon from './img/refresh_icon.svg';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useRef, useEffect } from 'react';
import {
  DropDownSelector,
  SearchComponent,
  ButtonBasic,
  TableBox,
} from '@lk-gtcom/ecomlab-components';
import { fetchFilterV3 } from '../../common/filtersFunc';
import {
  KonstantinCreateProductHttps,
  KonstantinMasterHttps,
} from '../../fetchUrls';
import useGeneralStore from '../../store/general';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { RequestController } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { periodWeek } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';
import './SetPriceAndMargin.scss';


const SetPriceAndMargin = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'set-price-and-margin');
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());

  // Фильтры
  const filterConfig = [
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'offerId', type: 'multi' },
    { key: 'search', type: 'single' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);

  // Поиск
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [defaultSearchValue, setDefaultSearchValue] = useState('')

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [tableUrl, setTableUrl] = useState('');
  const [tableBody, setTableBody] = useState(null);
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.search) {
          setSearchValue(urlParams.search?.value)
          setDefaultSearchValue({
            value: urlParams.search?.value,
            label: urlParams.search?.label
          })
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  // Первая инициализация url
  useEffect(() => {
    if (!isReady) return;
    updateURL({
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      search: urlParams?.search ? urlParams.search?.value : null,
    })
  }, [isReady]);

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `${KonstantinMasterHttps}/mp-products/tables/prices${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      offer_id_name_search: searchValue,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setTable(json);
        setTableUrl(url);
        setTableBody(body);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  };

  // Поиск
  const fetchSearch = ([search, page = 1], abortController = new AbortController()) => {
    let url = `${KonstantinMasterHttps}/mp-products/filters/offer-id-name`;

    const body = JSON.stringify({
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        let result = [];
        if (json) {
          result = json?.filter_data?.map(({ id, name, image }, ind) => {
            return { label: name, value: id, image: image };
          });
        }
        setSearchData(result);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  };

  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      controller,
      setTotal: setTotalApi,
      filter: 'mp_product_api_ids'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedApi,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      filter: 'mp_product_categories'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      selectedApi,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      filter: 'mp_product_brands'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, dateFrom, dateTo, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, dateFrom, dateTo, brandPage, brandQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    return () => {
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    if (selectedApi?.length > 0 && isReady) {
      fetchTableData([], abortController);
    }
    return () => abortController.abort();
  }, [isTableRequest]);

  const fetchOnePrice = (
    mpId,
    apiId,
    offerId,
    newPrice,
    setStatus,
    colName
  ) => {
    let url = `${KonstantinCreateProductHttps}/mp_products/prices`;

    const prices = [
      {
        obj_to_change: colName === 'Цена' ? 'price' : 'old_price',
        offer_id: offerId,
        ...(colName === 'Цена' ? { price: newPrice } : { old_price: newPrice }),
      },
    ];

    const body = JSON.stringify({
      mp_id: mpId,
      api_id: apiId,
      prices,
    });

    fetch(url, { body, method: 'POST', headers })
      .then((res) => {
        if (res.ok) {
          setStatus('success');
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        // const abortController = new AbortController();
        // fetchTableData([], abortController);
        // return () => abortController.abort();
      })
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  const handleSaveOnePrice = (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = inputEvent?.id;
    const colName = actionEvent?.[2];
    const mpId = actionEvent?.[0]?.mp_id;
    const apiId = actionEvent?.[0]?.api_id;

    let newPrice;

    newPrice = +inputEvent?.value;

    if (newPrice) {
      setStatus('loading');
      fetchOnePrice(mpId, apiId, offerId, newPrice, setStatus, colName);
    } else {
      setStatus('error');
    }
  };

  return (
    <div className="product-prices">
      <TitlePage
        title='Цены товаров'
      />

      <FilterContainer
        loading={isSaved}
        saveFilters={saveFilters}
        clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
        onReset={(e) => {
          setSelectedApi([]);
          setSelectedCategory([]);
          setSelectedBrand([]);
          updateURL({
            api: null,
            category: null,
            brand: null,
            offerId: null,
            search: null
          });
          setIsFilterRequest(!isFilterRequest);
          setIsTableRequest(!isTableRequest)
        }}
      >
        <DropDownSelector
          options_prop={apiData}
          state={selectedApi}
          setState={setSelectedApi}
          placeholder="Площадка"
          total={totalApi}
          multi
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
          onBlur={() => {
            updateURL({ api: selectedApi });
            filtersCategory();
            filtersBrand();
            setIsTableRequest(!isTableRequest);
          }}
        />

        <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          total={totalCategory}
          multi={true}
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          onBlur={() => {
            updateURL({ category: selectedCategory });
            filtersBrand();
            setIsTableRequest(!isTableRequest);
          }}
        />

        <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          total={totalBrand}
          multi={true}
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          onBlur={() => {
            updateURL({ brand: selectedBrand });
            setIsTableRequest(!isTableRequest);
          }}
        />

        <SearchComponent
          searchValue={searchValue}
          errSearch={false}
          placeholder="Поиск товара"
          errText="Неверный товар"
          setSearchValue={setSearchValue}
          fetchData={(e) => setIsTableRequest(!isTableRequest)}
          fetchCallback={fetchSearch}
          data={searchData}
          onClearDependence={[isFilterRequest]}
          updateURL={updateURL}
          value={defaultSearchValue}
        />
      </FilterContainer>

      <TableBox
        {...tableProps}
        paginator={true}
        ref={paginatorRef}
        fetchCallback={fetchTableData}
        tableUrl={tableUrl}
        tableBody={tableBody}
        upload
        onInputAction={(e) => handleSaveOnePrice(e)}
        child={<ButtonBasic
          violet
          icon={refresh_icon}
          onClick={(e) => setIsTableRequest(!isTableRequest)}
          text={'Обновить цены'}
          width="auto"
          size="32px"
        />}
      />
    </div>
  );
};

export { SetPriceAndMargin };
